module.exports = __webpack_public_path__ + "img/12_50.d4b95170.jpg";